import { LinkV2, styled } from '@withjoy/joykit';

export const StyledLinkV2 = styled(LinkV2)`
  text-underline-offset: 2px;
  text-decoration-color: ${({ theme }) => theme.colors.mono5};
  :hover {
    text-decoration-color: ${({ theme }) => theme.colors.mono8};
  }
  :visited,
  :active {
    text-decoration-color: ${({ theme }) => theme.colors.mono14};
  }
`;
